import React, { useState } from 'react'
import { SearchIconBlue, CloseIcon } from '@pga/pga-component-library'
import { withRouter } from 'react-router'
import { Container } from 'reactstrap'
import PlacesLocationInput from '../../SearchFilters/LocationFilter/PlacesLocationInput'
import { onSearchSubmit } from './helpers'
import {
  StyledForm,
  StyledInputWrapper,
  StyledLocationInputWrapper,
  StyledInputSearch,
  StyledButton,
  StyledSearchIconWrapper,
  StyledSearchClearWrapper,
  StyledButtonWrapper,
  MainWrapper
} from './styles'
import { defaultState, searchStateToUrl } from '../../utils'
import { mergeDeepRight } from 'ramda'
import { getSuggestionText } from '../../SearchFilters/LocationFilter/utils'

export const SearchForm = (props) => {
  const { history } = props
  const [keywordsInputVal, setKeywordsInputVal] = useState('')
  const [locationValue, setLocationValue] = useState({})

  const handleSelect = (selectedState, selectedVal) => {
    const searchState = mergeDeepRight(defaultState, selectedState)
    const url = searchStateToUrl(props, searchState)
    const locationValue = getSuggestionText(selectedVal)

    const pushUrl = `/search${url.slice(url.indexOf('?'))}`
    history.push(pushUrl, { locationValue })
  }

  return (
    <StyledForm>
      <Container>
        <MainWrapper>
          <StyledInputWrapper>
            <StyledSearchIconWrapper>
              <SearchIconBlue />
            </StyledSearchIconWrapper>
            <StyledInputSearch
              placeholder='Job Title, Keywords'
              value={keywordsInputVal}
              onChange={(event) => setKeywordsInputVal(event.target.value)}
            />
            {keywordsInputVal && (
              <StyledSearchClearWrapper>
                <CloseIcon onClick={() => setKeywordsInputVal('')} />
              </StyledSearchClearWrapper>
            )}
          </StyledInputWrapper>
          <StyledLocationInputWrapper>
            <PlacesLocationInput
              handleSelect={handleSelect}
              onLocationStateChange={(result) => setLocationValue(result)}
            />
          </StyledLocationInputWrapper>
          <StyledButtonWrapper>
            <StyledButton onClick={(event) => {
              event.preventDefault()
              onSearchSubmit(history, { keywordsInputVal, locationValue })
            }}>
              Search
            </StyledButton>
          </StyledButtonWrapper>
        </MainWrapper>

      </Container>
    </StyledForm>
  )
}

export default withRouter(SearchForm)
